import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import Navbar from "../../../Navbar/Navbar";
import NavbarBacks from "../../../../components/BackOffice/Navbar/Navbar";
import UserAvatar from "../../../ui/userAvatar";
import SideMenu from "../../../Utils/SideMenu";
import BoxItem from "./../../components/box-item";
import ContentTitle from "./../../components/content-title";
import SendMessage from "./../../components/send-message";
import CrossIcon from "../../../../assets/components-icons/CrossIcon";
import SectionDetail from "../../components/section-detail";
import "./../../messengers-page.sass";
import ArrowLeft from "../../../../assets/components-icons/ArrowLeft";
import messagesJson from "./tradMessages.json";
import useCurrentLanguage from "../../../../services/currentlenguaje";
import { loadUserData } from "../../../../Helpers"; // ✅ AGREGAR: Import

const MessaggesDesktop = ({ users, userId }) => {
  const { handleFilterLang } = useCurrentLanguage();
  const router = useHistory();
  
  // ✅ AGREGAR: Obtener datos del usuario logueado
  const userdata = loadUserData();
  
  const [openDetails, setOpenDetails] = useState(false);
  const [chatMobile, setChatMobile] = useState(false);
  const [housingMobile, setHousingMobile] = useState(false);
  const [usersMobile, setUsersMobile] = useState(true);
  const [refMessages, setRefMessages] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [userHousing, setUserHousing] = useState([]);
  const [activeBox, setActiveBox] = useState(null);

  const viewDetails = () => {
    if (userHousing.id) {
      setOpenDetails(true);
      setChatMobile(false);
      setHousingMobile(true);
    }
  };
  
  const viewChat = () => {
    setOpenDetails(false);
    setChatMobile(true);
    setHousingMobile(false);
  };
  
  const buttonBack = () => {
    if (chatMobile) {
      setChatMobile(false);
      setUsersMobile(true);
    }
    if (housingMobile) {
      setChatMobile(true);
      setHousingMobile(false);
    }
  };
  
  const refClickUser = useRef(null);

  useEffect(() => {
    if (refClickUser.current) {
      refClickUser.current.focus();
    }
  }, [userHousing]);

  useEffect(() => {
    setOpenDetails(false);
  }, [userInfo]);

  return (
    <div className="layoutMessages">
      {router.location.pathname.includes("back-office") ? (
        <NavbarBacks />
      ) : (
        <Navbar />
      )}

        
        <div
          className={`layoutMessages__containerSide ${
            router.location.pathname.includes("back-office") && "grid-cols-1"
          }`}
        >
          {!router.location.pathname.includes("back-office") && (
            <div className="layoutMessages__containerSide__sideBar">
              <SideMenu />
            </div>
          )}
          <div className="layoutMessages__container">
            <div
              className={`layoutMessages__container__section ${
                router.location.pathname.includes("back-office") && "max-w-full"
              }`}
            >
              <div className={"layoutMessages__container__section__chats"}>
                {users.map((e) => {
                  // ✅ DEBUGGING: Agregar console.log para ver los datos
                  console.log("🔍 DEBUGGING BoxItem Data:", {
                    lastMessage: e.lastMessage,
                    currentUserId: userdata?.id || userId,
                    from: e.lastMessage.from,
                    to: e.lastMessage.to
                  });
                  
                  // ✅ CORREGIR: Usar userdata.id en lugar de userId prop undefined
                  const currentUserId = userdata?.id || userId;
                  
                  // ✅ MEJORAR: Convertir a string para comparación segura
                  const currentUserIdStr = String(currentUserId);
                  const fromIdStr = String(e.lastMessage.from.id);
                  const toIdStr = String(e.lastMessage.to.id);
                  
                  // El "otro usuario" es quien no es el usuario logueado
                  let otherUser;
                  if (fromIdStr === currentUserIdStr) {
                    // Si el último mensaje lo envió el usuario logueado, el "otro" es el destinatario
                    otherUser = e.lastMessage.to;
                  } else {
                    // Si el último mensaje lo envió otra persona, esa es el "otro usuario"
                    otherUser = e.lastMessage.from;
                  }

                  // ✅ DEBUGGING: Ver qué usuario se está pasando a BoxItem
                  console.log("👤 DEBUGGING otherUser:", {
                    currentUserIdStr,
                    fromIdStr,
                    toIdStr,
                    condition: fromIdStr === currentUserIdStr ? 'FROM es usuario logueado -> mostrar TO' : 'FROM NO es usuario logueado -> mostrar FROM',
                    otherUser
                  });

                  // Transformar los datos para que coincidan con lo que espera BoxItem
                  const transformedMessageInfo = {
                    content: e.lastMessage.message,
                    createdAt: e.lastMessage.issued,
                  };

                  return (
                    <BoxItem
                      key={e.lastMessage.id} // ✅ CAMBIAR: Usar ID del mensaje que es único
                      user={otherUser}
                      activeBox={activeBox}
                      setActiveBox={setActiveBox}
                      refMessages={refMessages}
                      getUser={(value) => setUserInfo(value)}
                      messageInfo={transformedMessageInfo}
                      refClickUser={refClickUser}
                      setChatMobile={setChatMobile}
                      setUsersMobile={setUsersMobile}
                    />
                  );
                })}
              </div>
            </div>
            {userInfo === null ? (
              <h2 className="layoutMessages__container__empty">
                {handleFilterLang(messagesJson).elegirConversacion}
              </h2>
            ) : (
              <div
                className={`layoutMessages__container__section ${
                  router.location.pathname.includes("back-office") &&
                  "max-w-full"
                }`}
              >
                <div
                  onClick={() => viewDetails()}
                  className={"layoutMessages__container__section__header"}
                >
                  {userInfo && <UserAvatar userData={userInfo} size={40} />}
                  <ContentTitle title={userInfo.firstName} />
                  <p className="flex items-center gap-1 text-xs ">
                    {handleFilterLang(messagesJson).verAlohamiento}
                    <ArrowLeft size={16} className={"rotate-180"} />
                  </p>
                </div>
                <SendMessage
                  userId={userId}
                  user={userInfo}
                  setUserHousing={setUserHousing}
                  refClickUser={refClickUser}
                  setRefMessages={setRefMessages}
                />
              </div>
            )}
            {openDetails && (
              <div
                className={
                  openDetails
                    ? `layoutMessages__container__sectionDetail `
                    : `layoutMessages__container__section `
                }
              >
                <div className={"layoutMessages__container__section__header"}>
                  <div
                    className="layoutMessages__container__section__header__icon"
                    onClick={() => viewChat()}
                  >
                    <CrossIcon />
                  </div>
                  <ContentTitle
                    title={handleFilterLang(messagesJson).detalles}
                  />
                </div>
                <SectionDetail
                  userHousing={userHousing}
                  userInfo={userInfo}
                />
              </div>
            )}
          </div>
        </div>
    </div>
  );
};

export default MessaggesDesktop;
